export default __webpack_public_path__ + "c134ff98f60f17d22564c364ea82264d.pdf";